import '../styles/components/Footer.scss';

const Footer = () =>{
return(
    <footer className='footer'>
        <p className='footer_text'>Search your favourites Rick & Morty's characters!</p>
        <p className='footer_copy'>Lucía Kestel &copy; 2022</p>
    </footer>
)
};

export default Footer;